<template>
  <g opacity="0.4">
    <path
      d="M69.3678 12.3851C65.639 8.50587 61.1718 5.41179 56.2293 3.285C51.2867 1.15821 45.9686 0.0416836 40.588 0.00114503C35.2075 -0.0393935 29.8732 0.996873 24.8991 3.04895C19.9251 5.10102 15.4118 8.12743 11.625 11.95C-3.64392 27.3428 -3.90231 52.4043 11.0317 68.1108C17.5915 75.0197 26.3849 79.3841 35.8542 80.4308C45.3236 81.4775 54.8578 79.1391 62.7682 73.8298L91.9296 104.151C92.1082 104.337 92.3217 104.487 92.5579 104.59C92.7941 104.694 93.0485 104.75 93.3064 104.755C93.5642 104.76 93.8206 104.714 94.0608 104.62C94.301 104.526 94.5202 104.386 94.706 104.207L101.973 97.2195C102.159 97.041 102.308 96.8275 102.412 96.5913C102.515 96.3551 102.571 96.1007 102.576 95.8428C102.581 95.5849 102.536 95.3286 102.441 95.0884C102.347 94.8482 102.207 94.629 102.028 94.4431L72.8666 64.1216C78.4572 56.462 81.1708 47.0779 80.5309 37.6167C79.8911 28.1555 75.9387 19.2222 69.3678 12.3851ZM60.2845 61.1422C56.1718 65.0983 50.9784 67.746 45.361 68.7505C39.7436 69.7551 33.9544 69.0713 28.7256 66.7857C23.4967 64.5001 19.0631 60.7153 15.9853 55.9099C12.9075 51.1045 11.3238 45.4943 11.4344 39.7889C11.545 34.0834 13.345 28.5388 16.6068 23.8563C19.8685 19.1739 24.4456 15.5638 29.7591 13.4825C35.0725 11.4013 40.8839 10.9425 46.4581 12.164C52.0324 13.3855 57.1193 16.2326 61.0755 20.3451C63.7023 23.0758 65.7656 26.2972 67.1475 29.8253C68.5294 33.3534 69.2029 37.1191 69.1294 40.9075C69.056 44.6958 68.2371 48.4326 66.7195 51.9045C65.2018 55.3764 63.0152 58.5153 60.2845 61.1422Z"
      :fill="iconColor"
    />
    <path
      d="M18.9177 32.3129C15.672 32.3129 15.6667 37.3542 18.9177 37.3542C22.1687 37.3542 22.166 32.3129 18.9177 32.3129Z"
      :fill="iconColor"
    />
    <path
      d="M41.5347 16.1685C32.8021 15.9708 24.8526 20.3529 20.6286 26.9788C19.2497 29.1356 23.1651 31.0419 24.5361 28.8957C28.035 23.4194 34.6846 19.931 41.8695 20.1235C49.4051 20.3134 56.2631 24.6243 59.8937 30.6069C61.2727 32.877 64.8796 30.8125 63.5112 28.5556C59.1054 21.2916 50.5573 16.3742 41.5347 16.1685Z"
      :fill="iconColor"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#ee1c25"
    }
  }
};
</script>
